import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

// v0.4.0 Phase 2 批 2C-2: 装备库整页 (Page 模式, 跟 EquipmentSelectModal 职责不同)
// EquipmentSelectModal = 类型选择器 (modal 模式让用户上传装备图片)
// EquipmentPage = 装备库浏览器 (整页 Page 模式让用户浏览现有装备 + toggle 选/未选 + 应用)

// 拍板: 32 案例 namespace 跟 round 1+ 一致 = apiUrl + '/ziven/seedream/equipment'
// 拍板: EQUIPMENT_TYPES 跟 EquipmentSelectModal 一致 = 跨组件可互操作 (type key 9 类)

// Phase 1 i18n — translator.trans() 返回 vnode array，flatten 为 string。
// WHY: see memory/flarum-1.8-pitfalls.md 坑 B
function t(key) {
  const result = app.translator.trans(key);
  return Array.isArray(result) ? result.join('') : result;
}

// 有占位符的翻译（"已选 N 件"），保留 vnode array 让 mithril 当 children 渲染。
// WHY: t() flatten 会丢 vnode，导致 rich placeholder 失效。tRich() 保留 array 结构。
function tRich(key, params) {
  return app.translator.trans(key, params || {});
}

// label 改成 function lazy 调用（避免 module top-level 时 translator 未就绪）
const EQUIPMENT_TYPES = [{
  key: 'all',
  label: () => t('ziven-dress-up.forum.common.equipment_all'),
  icon: 'fa-th'
}, {
  key: 'clothing',
  label: () => t('ziven-dress-up.forum.common.equipment_clothing'),
  icon: 'fa-tshirt'
}, {
  key: 'pants',
  label: () => t('ziven-dress-up.forum.common.equipment_pants'),
  icon: 'fa-vest-patches'
}, {
  key: 'helmet',
  label: () => t('ziven-dress-up.forum.common.equipment_helmet'),
  icon: 'fa-hard-hat'
}, {
  key: 'boots',
  label: () => t('ziven-dress-up.forum.common.equipment_boots'),
  icon: 'fa-shoe-prints'
}, {
  key: 'goggles',
  label: () => t('ziven-dress-up.forum.common.equipment_goggles'),
  icon: 'fa-glasses'
}, {
  key: 'snowboard',
  label: () => t('ziven-dress-up.forum.common.equipment_snowboard'),
  icon: 'fa-person-skiing'
}];
export default class EquipmentPage extends Page {
  constructor() {
    super(...arguments);
    // v0.4.0 round 2 fix: Flarum 1.8 Page.bodyClass 写到 #app (不是 body),
    // 用 class selector 隔离 ziven-dress-up 路由范围 = 不污染 Flarum 全局
    _defineProperty(this, "bodyClass", 'App--equipment');
  }
  oninit(vnode) {
    super.oninit(vnode);

    // 装备库 list
    this.equipment = [];
    this.loading = true;

    // tab filter (默认 all = 不过滤)
    this.activeType = 'all';

    // 选中的装备 ID 集合 (跨 tab 持久)
    this.selectedIds = Stream(new Set());

    // 错误状态
    this.loadError = '';
    this.loadErrorDetail = '';

    // 加载装备库
    this.loadEquipment();
  }
  loadEquipment() {
    const self = this;
    // 32 案例 namespace 拍板: apiUrl + '/ziven/seedream/equipment'
    let url = app.forum.attribute('apiUrl') + '/ziven/seedream/equipment';
    if (this.activeType && this.activeType !== 'all') {
      url += '?type=' + this.activeType;
    }
    return app.request({
      method: 'GET',
      url: url
    }).then(function (response) {
      if (response && response.success && response.data && Array.isArray(response.data.items)) {
        self.equipment = response.data.items;
      } else {
        console.warn('Failed to load equipment:', response);
        self.loadError = t('ziven-dress-up.forum.equipment_page.load_error');
        self.loadErrorDetail = '';
      }
    }).catch(function (error) {
      console.error('Failed to load equipment:', error);
      self.loadError = tRich('ziven-dress-up.forum.equipment_page.load_error_with_detail', {
        detail: error && error.message || t('ziven-dress-up.forum.common.unknown_error')
      });
      self.loadErrorDetail = error && error.message || '';
    }).then(function () {
      self.loading = false;
      m.redraw();
    });
  }

  /**
   * 切换 tab (type 过滤)
   */
  switchType(typeKey) {
    if (this.activeType === typeKey) return;
    this.activeType = typeKey;
    this.loading = true;
    this.loadEquipment();
  }

  /**
   * 切换装备 选/未选
   */
  toggleEquipment(id) {
    const ids = new Set(this.selectedIds());
    if (ids.has(id)) {
      ids.delete(id);
    } else {
      ids.add(id);
    }
    this.selectedIds(ids);
    m.redraw();
  }

  /**
   * 应用选中的装备 → 回 SeedreamPage (用 m.route.back)
   */
  applySelected() {
    const ids = Array.from(this.selectedIds());
    if (ids.length === 0) return;

    // 拍板: V 测验证 modal 不需要持久化到后端, MVP 阶段仅记录到 console + 回退
    console.log('Applied equipment IDs:', ids);

    // 拍板: 跳回 SeedreamPage (用户操作完成后自然返回)
    if (m.route.get() === '/equipment') {
      m.route.set('/dressUp');
    } else {
      window.history.back();
    }
  }

  /**
   * 取消 / 返回 SeedreamPage
   */
  goBack() {
    if (m.route.get() === '/equipment') {
      m.route.set('/dressUp');
    } else {
      window.history.back();
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        class: "EquipmentPage",
        style: {
          minHeight: '100vh'
        }
      }, m("div", {
        class: "equipment-container"
      }, m("h2", {
        class: "equipment-title"
      }, m("i", {
        class: "fas fa-snowflake"
      }), ' ' + t('ziven-dress-up.forum.equipment_page.title')), m("div", {
        class: "equipment-loading"
      }, m(LoadingIndicator, {
        component: {
          size: 'large'
        }
      }), m("p", null, ' ' + t('ziven-dress-up.forum.equipment_page.loading')))));
    }
    if (this.loadError) {
      return m("div", {
        class: "EquipmentPage",
        style: {
          minHeight: '100vh'
        }
      }, m("div", {
        class: "equipment-container"
      }, m("h2", {
        class: "equipment-title"
      }, m("i", {
        class: "fas fa-snowflake"
      }), ' ' + t('ziven-dress-up.forum.equipment_page.title')), m("div", {
        class: "equipment-error"
      }, m("i", {
        class: "fas fa-exclamation-circle"
      }), m("p", null, this.loadError), m(Button, {
        class: "btn-glass",
        onclick: () => this.loadEquipment()
      }, m("i", {
        class: "fas fa-sync-alt"
      }), ' ' + t('ziven-dress-up.forum.common.retry')))));
    }
    const selected = this.selectedIds();
    const selectedCount = selected.size;
    return m("div", {
      class: "EquipmentPage",
      style: {
        overflow: 'visible',
        minHeight: '100vh'
      }
    }, m("div", {
      class: "equipment-container"
    }, m("h2", {
      class: "equipment-title"
    }, m("i", {
      class: "fas fa-snowflake"
    }), ' ' + t('ziven-dress-up.forum.equipment_page.title')), m("div", {
      class: "equipment-header-actions"
    }, m(Button, {
      class: "btn-glass",
      onclick: () => this.goBack()
    }, m("i", {
      class: "fas fa-arrow-left"
    }), ' ' + t('ziven-dress-up.forum.common.back')), m("span", {
      class: "selected-badge"
    }, tRich('ziven-dress-up.forum.equipment_page.selected_count', {
      count: selectedCount
    }))), m("div", {
      class: "equipment-type-tabs"
    }, EQUIPMENT_TYPES.map(type => m("div", {
      class: "equipment-type-tab ".concat(this.activeType === type.key ? 'active' : ''),
      key: type.key,
      onclick: () => this.switchType(type.key)
    }, m("i", {
      class: "fas ".concat(type.icon)
    }), m("span", null, typeof type.label === 'function' ? type.label() : type.label)))), this.equipment.length === 0 ? m("div", {
      class: "equipment-empty"
    }, m("i", {
      class: "fas fa-box-open"
    }), m("p", null, ' ' + t('ziven-dress-up.forum.equipment_page.empty'))) : m("div", {
      class: "equipment-grid"
    }, this.equipment.map(item => {
      const isSelected = selected.has(item.id);
      return m("div", {
        class: "equipment-card ".concat(isSelected ? 'selected' : ''),
        key: item.id,
        onclick: () => this.toggleEquipment(item.id)
      }, m("div", {
        class: "equipment-thumbnail"
      }, m("i", {
        class: "fas ".concat(item.icon)
      })), m("div", {
        class: "equipment-info"
      }, m("div", {
        class: "equipment-name"
      }, item.name), m("div", {
        class: "equipment-type"
      }, this.getTypeLabel(item.type))), isSelected && m("div", {
        class: "equipment-selected-check"
      }, m("i", {
        class: "fas fa-check"
      })));
    })), m("div", {
      class: "equipment-footer"
    }, m(Button, {
      class: "btn-amber",
      disabled: selectedCount === 0,
      onclick: () => this.applySelected()
    }, m("i", {
      class: "fas fa-check-circle"
    }), ' ' + tRich('ziven-dress-up.forum.equipment_page.apply_button', {
      count: selectedCount
    })))));
  }

  /**
   * type key → label (Phase 1 i18n: 走 common.equipment_types 共享 namespace)
   */
  getTypeLabel(typeKey) {
    const key = 'ziven-dress-up.forum.common.equipment_' + typeKey;
    const translated = t(key);
    // fallback: yml 缺 key 时 t() 返回 key 字符串，做防御性判断
    return translated === key ? typeKey || '' : translated;
  }
}
flarum.reg.add('ziiven-dress-up', 'forum/components/EquipmentPage', EquipmentPage);